import { render, staticRenderFns } from "./JourneyCanvas.vue?vue&type=template&id=4d18c300&scoped=true&"
import script from "./JourneyCanvas.vue?vue&type=script&lang=js&"
export * from "./JourneyCanvas.vue?vue&type=script&lang=js&"
import style0 from "./JourneyCanvas.vue?vue&type=style&index=0&id=4d18c300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d18c300",
  null
  
)

export default component.exports